<template>
  <div>
    <input
      ref="image"
      type="file"
      accept="image/*"
      @change="Image()"
      class="d-none"
    />
    <v-btn
      icon
      :disabled="
        !Editing || (LastQuestion ? LastQuestion.type === 'quickReply' : false)
      "
      @click="$refs.image.click()"
    >
      <v-icon>mdi-image</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["questioninfo", "Editing", "LastQuestion"],
  methods: {
    Image() {
      for (const key in this.$refs.image.files) {
        if (Object.hasOwnProperty.call(this.$refs.image.files, key)) {
          const element = this.$refs.image.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-${vm.questioninfo.questionType}/question/`
            );
            formData.append(
              "fileName",
              `${Date.now()}-${vm.questioninfo.questionType}-`
            );
            this.$store.commit("ToggleLoading");
            this.$store
              .dispatch("UploadFormData", formData)
              .then((req) => {
                this.$emit("sendimage", req.data);
                this.$store.commit("ToggleLoading");
              })
              .catch(() => {
                this.$store.commit("ToggleLoading");
              });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
              showCancelButton: false,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "ตกลง",
            }).then(() => {
              this.$refs.image.type = "text";
              this.$refs.image.type = "file";
            });
          }
        }
      }
      this.$refs.image.type = "text";
      this.$refs.image.type = "file";
    },
  },
};
</script>
